function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonnelSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m480 448h-448c-17.671875 0-32-14.328125-32-32v-309.332031c0-17.675781 14.328125-32 32-32h138.667969v21.332031h-138.667969c-5.890625 0-10.667969 4.777344-10.667969 10.667969v309.332031c0 5.890625 4.777344 10.667969 10.667969 10.667969h448c5.890625 0 10.667969-4.777344 10.667969-10.667969v-309.332031c0-5.890625-4.777344-10.667969-10.667969-10.667969h-138.667969v-21.332031h138.667969c17.671875 0 32 14.324219 32 32v309.332031c0 17.671875-14.328125 32-32 32zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.667969 490.667969h234.664062v21.332031h-234.664062zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.667969 437.332031h21.332031v64h-21.332031zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 437.332031h21.332031v64h-21.332031zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.667969 170.667969h-21.335938c-29.4375-.035157-53.296875-23.894531-53.332031-53.335938v-64c.035156-29.4375 23.894531-53.2968748 53.332031-53.332031h21.335938c29.4375.0351562 53.296875 23.894531 53.332031 53.332031v64c-.035156 29.441407-23.894531 53.300781-53.332031 53.335938zm-21.335938-149.335938c-17.671875 0-32 14.328125-32 32v64c0 17.675781 14.328125 32 32 32h21.335938c17.671875 0 32-14.324219 32-32v-64c0-17.671875-14.328125-32-32-32zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.332031 85.332031h-42.664062c-2.828125 0-5.542969-1.125-7.542969-3.125l-13.792969-13.792969-13.789062 13.792969c-2 2-4.714844 3.125-7.542969 3.125h-21.332031v-21.332031h16.917969l18.207031-18.207031c4.164062-4.164063 10.917969-4.164063 15.082031 0l18.207031 18.207031h38.25zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.667969 362.667969h-213.335938c-5.890625 0-10.664062-4.777344-10.664062-10.667969v-96c.046875-41.21875 33.449219-74.621094 74.664062-74.667969 4.367188 0 8.292969 2.65625 9.910157 6.710938l32.757812 81.910156 32.757812-81.910156c1.617188-4.054688 5.542969-6.710938 9.910157-6.710938 41.214843.046875 74.617187 33.449219 74.664062 74.667969v96c0 5.890625-4.773437 10.667969-10.664062 10.667969zm-202.667969-21.335938h192v-85.332031c-.035156-26.722656-19.808594-49.308594-46.292969-52.875l-39.796875 99.5c-1.617187 4.054688-5.542968 6.71875-9.910156 6.71875s-8.292969-2.664062-9.910156-6.71875l-39.796875-99.5c-26.484375 3.566406-46.257813 26.152344-46.292969 52.875zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 309.332031c-1.65625.003907-3.285156-.378906-4.769531-1.117187l-64-32c-3.613281-1.808594-5.898438-5.503906-5.898438-9.546875v-32h21.335938v25.40625l53.332031 26.667969 53.332031-26.667969v-25.40625h21.335938v32c0 4.042969-2.285157 7.738281-5.898438 9.546875l-64 32c-1.484375.738281-3.113281 1.121094-4.769531 1.117187zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.332031 298.667969h21.335938v53.332031h-21.335938zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.667969 341.332031h458.664062v21.335938h-458.664062zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.667969 181.332031h-85.335938c-4.3125 0-8.199219-2.597656-9.851562-6.582031-1.648438-3.988281-.738281-8.574219 2.3125-11.625l42.664062-42.667969 15.085938 15.085938-24.460938 24.457031h59.585938zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.789062 178.214844 15.085938-15.085938 42.667969 42.667969-15.085938 15.085937zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.542969 220.875-15.085938-15.082031 24.460938-24.460938h-59.585938v-21.332031h85.335938c4.3125 0 8.199219 2.601562 9.851562 6.585938 1.648438 3.984374.738281 8.570312-2.3125 11.621093zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.460938 135.546875 15.082031-15.085937 42.667969 42.667968-15.082032 15.085938zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelSelection);
export default __webpack_public_path__ + "static/media/personnel_selection.d3a2205aae91823f935c145060a3f55d.svg";
export { ForwardRef as ReactComponent };